// Port of api/fuel/app/classes/filter/search/games/rules/query/collection_status.php
import Rule from 'offline/filter/core/search/rule'

var STATUS_MAP = {
	'own': 'own',
	'prevowned': 'prevowned',
	'fortrade': 'fortrade',
	'want': 'want',
	'wanttoplay': 'wanttoplay',
	'wanttobuy': 'wanttobuy',
	'wishlist': 'wishlist',
	'preordered': 'preordered',
	'hasparts': 'hasparts',
	'wantparts': 'wantparts'
}

function mapStatusField(value) {
	return 'c.collection_' + (STATUS_MAP[value] || value)
}

function buildQuery(rule, config, filter, data, query, logic) {
	var values = Rule.value(rule)
	var allowed = ['=', '!=']

	if (logic === 'some') {
		allowed = ['=', '!=', '>', '>=', '<', '<=']
	}

	var operand = Rule.operand(rule, allowed)
	var tolerance

	if (logic === 'one') {
		tolerance = 1
		operand = (operand === '=' || operand === '!=') ? ((rule.logic.operand === '=') ? '>=' : '<') : operand
	} else if (logic === 'some') {
		tolerance = rule.logic.tolerance
	} else if (logic === 'all') {
		tolerance = values.length
	}

	var fields = []
	for (var i = 0; i < values.length; i++) {
		fields.push(mapStatusField(values[i]))
	}

	query.where(fields.join(' + '), operand, tolerance)
}

export default Rule.create({
	name: 'collection_status',
	match: function(rule, config, filter, data, query) {
		var values = Rule.value(rule)
		query.where(mapStatusField(values[0]), Rule.operand(rule, ['=', '!=']), 1)
	},
	oneof: function(rule, config, filter, data, query) {
		buildQuery(rule, config, filter, data, query, 'one')
	},
	someof: function(rule, config, filter, data, query) {
		buildQuery(rule, config, filter, data, query, 'some')
	},
	allof: function(rule, config, filter, data, query) {
		buildQuery(rule, config, filter, data, query, 'all')
	}
})
